<link rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
<div class="main">

  <div class="row">

    <div class="user-details">
      <div class="user-icons">
        <span class="material-symbols-outlined" (click)="redirectToPage()">
          visibility
        </span>

        <span class="material-symbols-outlined " style="margin-left: 15px;" (click)="naviagateToEmployeeDetails()">
          border_color
        </span>

      </div>
      <div class="userinfodiv">
        <div class="user-photo">
          <div class="photo">
            <img
              src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
              alt="" srcset="">
          </div>
        </div>
        <div class="user-info">
          <div class="name">
            <span id="title">{{employeeInfo?.firstName}} {{employeeInfo?.lastName}}</span>
            <span id="subtitle">{{employeeInfo?.grade}}</span>
            <span id="subtitle">{{exp}} <span *ngIf="exp >= 1">+</span> Years exp.</span>
          </div>
          <div class="skills">
            <span id="inpool">In Pool</span>
            <span id="resume">Resume Uploaded &nbsp;&nbsp; &nbsp;&nbsp;<i
                [ngClass]="employeeInfo?.resume ? 'fas fa-check-circle mr-1 success' : 'fas fa-times-circle'"
                [ngStyle]="{'color': (employeeInfo?.resume) ? '#0c7c04' : '#ff0000'}"></i>
            </span>
          </div>


        </div>
      </div>



    </div>
    <div class="courses">
      <div class="certfications1">
        <div class="first-line1" id="rightandbottom">
          <span id="number">{{courseCompleted}}/{{totalCourses}}</span>
          <div class="playbtn">
            <span class="material-symbols-outlined">
              smart_display
            </span>
            <span id="boxtext">Completed Courses</span>
          </div>
        </div>
        <div class="second-line1" id="right">
          <span id="number">0</span>
          <div class="playbtn">
            <span class="material-symbols-outlined">
              smart_display
            </span>
            <span id="boxtext">certfications</span>
          </div>
        </div>
      </div>
      <div class="certfications">
        <div class="first-line">
          <span id="number">{{programPendingRequestCount}}</span>
          <div class="playbtn">
            <span class="material-symbols-outlined">
              smart_display
            </span>
            <span id="boxtext">Program Request Pending</span>
          </div>
        </div>
        <div class="second-line">
          <span id="number">{{myBadges}}</span>
          <div class="playbtn">
            <span class="material-symbols-outlined">
              smart_display
            </span>
            <span id="boxtext">My Badges</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>